import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { BulkUploadModal, ContentCard, PaginationKaBaap } from '../../Common';
import { handleApiExceptions, generate_query_set, alertify, goTo } from '../../../app_methods';
import { getAPIRequestsTableColumns, APIRequestsTableFilterNodes, VERIFICATION_PERMISSIONS, BULK_VERIFICATION_PERMISSIONS, VERIFICATION_SETTINGS, BULK_VERIFICATION_SETTINGS } from './constants';
import { APIRequest } from '../../../models';
import { connect } from 'react-redux';
import { Descriptions, Badge, Menu, Button, Icon, Dropdown } from 'antd';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Text4 } from '../../../styles';
import { APIRequestInfo } from './info';
import { API_REQUESTS_STATUS_TYPES } from '../../../constants';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';
import { VerificationModal } from '../../Common/VerificationModal';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import moment from 'moment';

const APIRequestsList = (props) => {
    const [APIRequests, setAPIRequests] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [showAPIRequestInfoDrawer, setShowAPIRequestInfoDrawer] = useState(false);
    const [selectedAPIRequest, setSelectedAPIRequest] = useState(false);
    const [showStatusInfoDrawer, setShowStatusInfoDrawer] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = moment().isBefore(_filters.created_at[1])?moment().format("YYYY-MM-DD"):_filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchAPIRequests = async (_pagination=pagination, _filters=filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await APIRequest.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) })
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(APIRequest, response.data.results)
        if (selectedAPIRequest.id) setSelectedAPIRequest(queryset.find(apiRequest => apiRequest.id == selectedAPIRequest.id));
        setAPIRequests(queryset);
        setPagination({ ..._pagination, ...response?.data?.pagination, current: _pagination?.current });
        setIsTableLoading(false);
    };

    const toggleAPIRequestInfoDrawer = (obj = {}) => {
        setSelectedAPIRequest(obj);
        setShowAPIRequestInfoDrawer(!showAPIRequestInfoDrawer);
    }

    const toggleBulkUploadModal = () => {
        setShowBulkUploadModal(!showBulkUploadModal);
    };

    const toggleVerificationModal = () => {
      setShowVerificationModal(!showVerificationModal);
    }

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchAPIRequests(_pagination, tableInfo.filters);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await APIRequest.download_report({ ...prepFilters(filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify(
            "Success",
            response?.data?.message || "Request generated Successfully",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Report Section",
                onOk: () => goTo(`/reports`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsDownloading(false);
    };

  const onVerify = () => {
    fetchAPIRequests(pagination, filters);
  }


    const tableColumns = getAPIRequestsTableColumns({setShowStatusInfoDrawer: setShowStatusInfoDrawer});

    // let filterNodes = APIRequestsTableFilterNodes({}, props.current_user);
    let filterNodes = APIRequestsTableFilterNodes({});

    useEffect(() => {
        props.onChildMount();
        let _filters = { ...filters };
        let defaultFilters = {};
        filterNodes.forEach(f => defaultFilters[f.field] = f.defaultValue);
        _filters = { ..._filters, ...defaultFilters };
        setFilters({ ..._filters });
        fetchAPIRequests(pagination, { ..._filters });
    }, []);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchAPIRequests({ ..._pagination }, filters);
    };

    const renderVerificationButton = () => {
        const verification_settings = _.some(VERIFICATION_SETTINGS.map((setting) => _.get(props,'current_user',{})[setting]), Boolean)
        const bulk_verification_settings = _.some(BULK_VERIFICATION_SETTINGS.map((setting) => _.get(props,'current_user',{})[setting]), Boolean)
        const verfication_permission = _.some(VERIFICATION_PERMISSIONS.map((permission) => _.get(props,'current_user.user.permissions',[]).includes(permission)), Boolean)
        const bulk_verification_permission = _.some(BULK_VERIFICATION_PERMISSIONS.map((permission) => _.get(props,'current_user.user.permissions',[]).includes(permission)), Boolean)

        const menu = (
            <Menu>
              <Menu.Item key="1" onClick={toggleBulkUploadModal}>
                <Icon type="upload" />Bulk Verifications
              </Menu.Item>
            </Menu>
        );

        if (verification_settings && bulk_verification_settings && verfication_permission && bulk_verification_permission){
            return (<Dropdown.Button type="primary" onClick={toggleVerificationModal} overlay={menu}>
                <> <FontAwesomeIcon icon={faCheckDouble} /> Verification</>
            </Dropdown.Button>)
        }
        else if (verification_settings && verfication_permission){
            return (<Button type="primary" onClick={toggleVerificationModal}>
                <> <FontAwesomeIcon icon={faCheckDouble} /> Verification</>
            </Button>)
        }
        else if (bulk_verification_settings && bulk_verification_permission){
            return (<Button type="primary" onClick={toggleBulkUploadModal}>
                Bulk Verifications
            </Button>)
        }
        else {
            return null
        }
    }

    return (
        <ContentCard className="p-3">
             <div className="w-100 d-flex justify-content-end">
                {renderVerificationButton()}
            </div>
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={APIRequests}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                pagination={pagination}
                totalRecords={pagination.total}
                filterNodes={filterNodes}
                onRow={(record) => ({
                    onClick: () => {
                        toggleAPIRequestInfoDrawer(record);
                    },
                })}
                // downloadable={true}
                downloadable={filters.api_type !== "PAN_VERIFICATION" && filters.api_type!=="GSTIN_VERIFICATION"}
                onDownload={downloadReport}
                isDownloading={isDownloading}
            />
            <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />

            <EaseDrawer
                visible={showStatusInfoDrawer}
                onClose={() => setShowStatusInfoDrawer(false)}
                hideFooter
                title="Verification Statuses"
                width={500}
            >
                <Descriptions bordered className="mt-3" size="small" layout="horizontal" column={1}>
                    {
                        Object.keys(API_REQUESTS_STATUS_TYPES).map((key, index) => {
                            return <Descriptions.Item label={<Badge color={API_REQUESTS_STATUS_TYPES[key].color} text={<Text4>{API_REQUESTS_STATUS_TYPES[key].label}</Text4>} />}>
                                {API_REQUESTS_STATUS_TYPES[key].description}
                            </Descriptions.Item>
                        })
                    }
                </Descriptions>
            </EaseDrawer>
            <APIRequestInfo
                visible={showAPIRequestInfoDrawer}
                onClose={toggleAPIRequestInfoDrawer}
                APIRequest={selectedAPIRequest}
            />
            <BulkUploadModal
                history={props.history}
                visible={showBulkUploadModal}
                toggleBulkUploadModal={toggleBulkUploadModal}
                showBatchType={true}
                bulkUploadModalType={"Bulk Verifications"}
                destroyOnClose={true}
                onSuccess={fetchAPIRequests}
            />

            <VerificationModal
                visible={showVerificationModal}
                toggleVerificationModal={toggleVerificationModal}
                onVerify={onVerify}
            />
        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps)(PermissionHoc(APIRequestsList, 'VIEW_VERIFICATIONS'));
